<div *ngIf="file.rxType == 'DIGITAL'" class="file-preview">
  <img *ngIf="file.statusCode == 'DRAFT'" src="assets\img\RX_Draft.svg" />
  <img *ngIf="file.statusCode != 'DRAFT'" src="assets\img\RX_Closed.svg" />
</div>

<div
  *ngIf="
    file.rxType != 'DIGITAL' &&
    file.fileType != 'pdf' &&
    file.fileType != 'html' &&
    !file.isVideo
  "
  class="file-preview"
  [style.background-image]="'url(' + file.url + ')'"
></div>

<div
  *ngIf="file.fileType == 'pdf' && file.rxType != 'DIGITAL'"
  class="file-preview"
>
  <img *ngIf="!file.rxSw" src="assets\img\PDF_Files.svg" />
  <img *ngIf="file.rxSw" src="assets\img\RX_pdf.svg" />
</div>

<div *ngIf="file.fileType == 'html'" class="file-preview">
  <img *ngIf="!file.modelType" src="assets\img\3D_Scan_new.svg" />
  <img
    *ngIf="file.modelType == 'IMPRINT'"
    src="assets\img\3D_scanner_icon.svg"
  />
  <img *ngIf="file.modelType == 'DESIGN'" src="assets\img\3D_cast_icon.svg" />
</div>
<div *ngIf="file.isVideo" class="file-preview">
  <img src="assets\img\VideoFile.svg" />
</div>
